export class LoanCatIdRequest{
    loanCategoryId?: number;

    constructor(loanCategoryId: number){
        this.loanCategoryId = loanCategoryId;
    }
}